import React, { useEffect, useState } from "react";
import { GuideCard } from "../../components/Cards";
import { getGuides } from "../../configs/productsConfig";
import Header from "../../components/Header";
import { Helmet } from "react-helmet-async";

function Guides() {

    const [products, setProducts] = useState([]);
    const text = 'Az alkotás igazi öröm, főleg akkor, ha minden szükséges segítség kéznél van. Ezeket az útmutatókat azért készítettem, hogy a csomagjaimban rejlő lehetőségeket könnyedén kiaknázhasd. Lépésről lépésre vezetnek végig az alkotás folyamatán. Miután megvásároltad a csomagot, az itt található tartalmak segítségedre lesznek abban, hogy örömteli és sikeres élménnyé váljon a kézműveskedés.';

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const data = await getGuides();
                setProducts(data);

            } catch (error) {
                console.error(error);
            }
        };
        fetchProducts();
    }, []);

    return (
        <div className="container-lg p-0 d-flex flex-column flex-sm-row flex-wrap justify-content-around mb-2">
            <Helmet>
                <title>Útmutatók – Kreatív Örömök</title>
                <meta name="description" content={text} />

                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "itemListElement": [
                        ${products
                            .filter(p => p.guide && p.guide.trim() !== "")
                            .map((product, index) => `{
                            "@type": "ListItem",
                            "position": ${index + 1},
                            "name": "Használati útmutató – ${product.name}",
                            "item": {
                            "@type": "MediaObject",
                            "contentUrl": "https://kreativoromok.hu${product.guide}",
                            "encodingFormat": "application/pdf"
                            }
                        }`).join(",")}
                    ]
                    }
                    `}
                </script>

            </Helmet>
            <Header pageName={'Útmutatók'} headerText={text} />

            {/* Kártyák */}
            <div className="d-flex col-12 flex-wrap justify-content-around">
                {products.map((product, index) => (
                    product.guide != '' ? <GuideCard key={index} product={product} /> : <></>
                ))}
            </div>
        </div>

    );
}

export default Guides;
